import { render, staticRenderFns } from "./chartDemo.vue?vue&type=template&id=2ffbc598&scoped=true"
import script from "./chartDemo.vue?vue&type=script&lang=js"
export * from "./chartDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffbc598",
  null
  
)

export default component.exports